import { defineMessages } from 'react-intl';

const messages = defineMessages({
  month: {
    id: 'monthDayField.month',
    defaultMessage: 'Month',
  },
  day: {
    id: 'monthDayField.day',
    defaultMessage: 'Day',
  },
});

export default messages;
